var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"append-icon":"mdi-close-circle","append-outer-icon":"mdi-send","filled":"","label":"Group name","type":"text"},on:{"click:append-outer":_vm.sendMessage,"click:append":_vm.resetValue},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }